import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link } from 'gatsby';
import styled from 'styled-components';

const Products = styled.div`
  @media (min-width: 768px) {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    gap: 1rem;
    justify-content: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  gap: 1rem;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

const ProductItem = styled.div`
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 24%;
    margin-left: 0;
    margin-right: 0;
    align-items: center;
    border-radius: 4px;
  }
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border-radius: 4px;
  width: 95%;
  background: white;
  transition: box-shadow 0.3s;
  :hover {
    box-shadow: 0 0 20px rgba(33, 33, 33, 0.2);
  }
`;

const ProductLink = styled(Link)`
  display: block;
  color: black;
  width: 100%;
  text-decoration: none;
  font-size: 1.125rem;
  padding: 0.75rem 0.25rem;
  text-align: center;
`;

const ImageLink = styled.a``;

const ProductImage = styled.img`
  @media (min-width: 768px) {
    margin-left: auto;
    margin-right: auto;
    display: block;
    max-height: 90%;
    max-width: 90%;
    object-fit: contain;
  }
  height: 95%;
  width: 95%;
  margin: 0.5rem;
`;

function SupportCategoryTemplate({ data }) {
  const productPages = data?.allSanityProductSupportPage?.nodes;
  return (
    <Products>
      {productPages.map(p => {
        let product = p.relatedProducts[0] ?? {};
        return (
          <ProductItem key={p.id}>
            <ImageLink href={`/product-support/${p.slug?.current}/`}>
              <ProductImage
                src={product?.store?.previewImageUrl}
              ></ProductImage>
            </ImageLink>
            <ProductLink to={`/product-support/${p.slug?.current}`}>
              {p.title}
            </ProductLink>
          </ProductItem>
        );
      })}
    </Products>
  );
}

export const query = graphql`
  query CategoryPages($categoryId: String = "") {
    allSanityProductSupportPage(
      filter: { supportCategory: { id: { eq: $categoryId } } }
    ) {
      nodes {
        id
        title
        slug {
          current
        }
        SEOMetadata {
          canonicalUrl
          description
          noFollow
          noIndex
          title
        }
        relatedProducts {
          store {
            previewImageUrl
            title
          }
        }
      }
    }
  }
`;

SupportCategoryTemplate.propTypes = {
  data: PropTypes.shape({
    allSanityProductSupportPage: PropTypes.shape({
      nodes: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        slug: PropTypes.shape({
          current: PropTypes.string,
        }),
      }),
    }),
  }),
};

export default SupportCategoryTemplate;
